import { AzureConfiguration } from "@/api/configurations";
import { Configuration, IPublicClientApplication, PublicClientApplication } from "@azure/msal-browser";

let instance: IPublicClientApplication | undefined;

let scopes: string[] = [];

function buildConfig(config?: AzureConfiguration): Configuration {
  return {
    auth: {
      clientId: config?.clientId ?? "",
      authority: config?.authority,
      knownAuthorities: config?.knownAuthorities,
      redirectUri: window.location.origin.endsWith("/") ? window.location.origin : window.location.origin + "/",
    },
    cache: {
      cacheLocation: "localStorage",
      storeAuthStateInCookie: false,
    },
  };
}

export const msal = {
  getInstance() {
    return instance;
  },

  createInstance(config?: AzureConfiguration) {
    if (!instance) {
      const msalConfig = buildConfig(config);
      instance = new PublicClientApplication(msalConfig);
      scopes = config?.scopes ?? [];
    }
    return instance;
  },

  logout() {
    return instance?.logoutRedirect();
  },

  async getAccessToken(instance: IPublicClientApplication) {
    const accounts = instance.getAllAccounts();
    if (accounts.length === 0) {
      throw new Error("No accounts found. Please login first.");
    }

    const request = {
      scopes,
      account: accounts[0],
    };

    return await instance.acquireTokenSilent(request);
  },
};
